import { render } from "./requestsRecived.vue?vue&type=template&id=446e675c&scoped=true"
import script from "./requestsRecived.vue?vue&type=script&lang=js"
export * from "./requestsRecived.vue?vue&type=script&lang=js"

import "./requestsRecived.vue?vue&type=style&index=0&id=446e675c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-446e675c"]])

export default __exports__